document.addEventListener('turbolinks:load', function() {
    var select = document.getElementById('attest_status');
    var observation = document.getElementById('observation');
  
    if (select){
      function toggleObservationRequired() {
        observation.required = (select.value === "Indeferido");
      }
    
      // Executa a função quando a página é carregada ou turbolinks navigation ocorre
      toggleObservationRequired();
    
      // Adiciona um ouvinte de evento para o evento change no select
      select.addEventListener('change', toggleObservationRequired);
    }
  });
  